import mutations from './mutations'
import actions from './action'
import getters from './getters'

export default {
  namespaced: true,
  state: {
    hasUploadTask: false, // 系统是否有上传任务正在执行
    uploadTaskShow: 0, // 设置 页面右下角 上传任务列表隐藏/展示
    message: '0' // 0: 无上传， 1：有工程上传， 2：有清单上传， 3：有组价上传 ("1,2" 表示 同时有工程文件 和 清单 在上传)
  },
  getters,
  actions,
  mutations,
  modules: {}
}
